<template>
<div class="solution" id="solution-top" @wheel="changeMove">
  <div class="so-con">
    <div class="solution-container sc1" id="sc1">
      <div class="one-solution s1" v-for="(item, ind) in solutionList" :key="ind + 'dd'" @mouseenter="activeItem = ind" :id="'solution'+ind" :class="{'active-item': activeItem == ind}">
        <div class="img-con" @click="toDetail(item)">
          <img :src="require('/static/image/home/'+item.solutionTitle+'.png')" alt="" />
        </div>
      </div>
    </div>
    <div class="solution-container sc2" id="sc2">
      <div class="one-solution s2" v-for="(item, ind) in solutionList" :key="ind + 'dd'" :id="'solutions'+ind" :class="{'active-item': activeItem == ind}">
        <div class="title-2">{{ $theme ? item.solutionTitle : item.solutionTitleEng.replace('and','&').replace('And','&') }}</div>
        <div class="line"></div>
        <div class="desc">
          {{ $theme ? item.resume : item.resumeEng}}
        </div>
        <div class="static">{{$theme ? "软件产品" : "Software products"}}（{{ item.softList.length }}）</div>
        <div class="static">{{$theme ? "硬件产品" : "Hardware products"}}（{{ item.hardList.length }}）</div>

      </div>
    </div>
  </div>
  <div class="process">
    <div class="step" id="step"></div>
  </div>
  <img class="point-bg" :src="pointBg" alt="">
  <div class="quan" :class="{'active-arrow': moveDistance != -1766}" @click="()=>{
    moveDistance=-1766;
    clickChange()
  }">
    <div class="con">
      <i class="el-icon-right"></i>
      <i class="el-icon-right"></i>
    </div>
  </div>
  <div class="quan quan2" :class="{'active-arrow': moveDistance != 0}" @click="()=>{
    moveDistance=0;
    clickChange()
  }">
    <div class="con">
      <i class="el-icon-right"></i>
      <i class="el-icon-right"></i>
    </div>
  </div>
</div>
</template>

<script>
import ModelSix from "@/views/home/components/model-six/Index.vue";
import pointBg from '/static/image/home/point-bg.png'
import Soft from "../product-detail/soft/Index.vue";
import Hard from "../product-detail/hard/Index.vue";
export default {
  data() {
    return {
      activeItem: 0,
      pointBg,
      solutionList: [],
      softwareList: [],
      hardwareList: [],
      showHeader: true,
      currentSolution: "",
      currentSoftList: [],
      currenthardList: [],
      currentSolution2: "",
      currentSoftList2: [],
      currenthardList2: [],
      temporarySolution: "",
      temporarySoftList: [],
      temporaryhardList: [],
      imgList: [
        require("/static/image/home/hyal-1.png"),
        require("/static/image/home/hyal-2.png"),
        require("/static/image/home/hyal-3.png"),
        require("/static/image/home/hyal-4.png"),
        require("/static/image/home/hyal-5.png"),
        require("/static/image/home/hyal-6.png"),
        require("/static/image/home/hyal-7.png"),
        require("/static/image/home/hyal-8.png"),
      ],
      softDetailVisible: false,
      hardDetailVisible: false,
      obj: null,
      height: null,
      moveDistance: 0,
    };

  },
  props: {},
  components: {
    ModelSix,
    Soft,
    Hard
  },
  computed: {},
  methods: {
    changeMove(e) {
      let y = -e.deltaY
      this.moveDistance += y
      if (this.moveDistance > 0) this.moveDistance = 0
      if (this.moveDistance < -1766) this.moveDistance = -1766
      var sc1 = document.getElementById("sc1");
      var sc2 = document.getElementById("sc2");
      var element2 = document.getElementById("step");
      element2.style.left = this.moveDistance * 500 / -1766 + 'px'

      sc1.style.transform = `translateX(${this.moveDistance}px)`
      sc2.style.transform = `translateX(${this.moveDistance}px)`

    },
    clickChange() {
      var sc1 = document.getElementById("sc1");
      var sc2 = document.getElementById("sc2");
      var element2 = document.getElementById("step");
      element2.style.left = this.moveDistance * 500 / -1766 + 'px'

      sc1.style.transform = `translateX(${this.moveDistance}px)`
      sc2.style.transform = `translateX(${this.moveDistance}px)`
    },
    changeSolution(item) {
      this.leaveSolution();
      if (item) {
        this.currentSolution = item.solutionTitle;
        this.currentSoftList = item.softList;
        this.currenthardList = item.hardList;
      } else {
        this.currentSolution = "";
        this.currentSoftList = [];
        this.currenthardList = [];
      }
    },
    hoverSolution(item) {
      console.log(item.solutionTitle);

      this.temporarySolution = item.solutionTitle;
      this.temporarySoftList = item.softList;
      this.temporaryhardList = item.hardList;
      if (this.currentSolution != "") {
        this.currentSolution2 = this.currentSolution;
        this.currentSolution = "";

        this.currentSoftList2 = this.currentSoftList;
        this.currentSoftList = [];

        this.currenthardList2 = this.currenthardList;
        this.currenthardList = [];
      }
    },
    leaveSolution(item) {
      this.temporarySolution = "";
      this.temporarySoftList = [];
      this.temporaryhardList = [];
      if (this.currentSolution2 != "") {
        this.currentSolution = this.currentSolution2;
        this.currentSolution2 = "";

        this.currentSoftList = this.currentSoftList2;
        this.currentSoftList2 = [];

        this.currenthardList = this.currenthardList2;
        this.currenthardList2 = [];
      }
    },

    toDetail(item) {
      console.log(item);
      const {
        href
      } = this.$router.resolve({
        path: `/solution/detail`,
        query: {
          code: item.code,
        },
      });
      window.open(href, "_blank");
    },
  },
  created() {
    let arr1 = [];
    let arr2 = [];
    let solutionDetail = JSON.parse(sessionStorage.getItem("solutionDetail")).map(item => {
      let content = JSON.parse(item.content) || {}

      return {
        code: item.code,
        title: content.title,
        resume: content.overview.overviewDetail,
        resumeEng: content.overview.overviewDetail_eng,
      }
    })
    this.solutionList = JSON.parse(sessionStorage.getItem("solutionTree")).map(
      (item) => {
        arr1.push(
          ...item.softwareProductList.map((ele) => {
            return {
              ...ele,
              parentName: item.solutionTitle,
              parentNameEng: item.solutionTitleEng,
            };
          })
        );
        arr2.push(
          ...item.hardwareList.map((ele) => {
            return {
              ...ele,
              parentName: item.solutionTitle,
              parentNameEng: item.solutionTitleEng,
            };
          })
        );
        let obj = solutionDetail.find(ele => ele.title == item.solutionTitle) || {}
        return {
          ...item,
          resume: obj.resume,
          resumeEng: obj.resumeEng,
          softList: item.softwareProductList.map((ele) => ele.title),
          hardList: item.hardwareList.map((ele) => ele.title),
        };
      }
    );
    let arr3 = []
    let arr4 = []
    arr2.forEach((item, index) => {
      if (!arr4.includes(item.title)) {
        arr3.push(item)
        arr4.push(item.title)
      }
    })
    this.softwareList = JSON.parse(JSON.stringify(arr1));
    this.hardwareList = JSON.parse(JSON.stringify(arr3));
  },
  mounted() {
    this.$bus.$emit('change-process')
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./Index.scss";
</style>
